(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import Cache from "../cache";

function makeCancellablePromise(promise) {
  let rejectFn;
  const cPromise = new Promise((resolve, reject) => {
    rejectFn = reject;
    Promise.resolve(promise).then(resolve).catch(reject);
  });
  cPromise.isCancelled = false;

  cPromise.cancel = () => {
    rejectFn({
      isCancelled: true
    });
    cPromise.isCancelled = true;
  };

  return cPromise;
}

const createPromiseMock = function (data) {
  let statusCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  return statusCode >= 200 && statusCode < 400 ? makeCancellablePromise(Promise.resolve({
    statusCode,
    data
  })) : // eslint-disable-next-line
  makeCancellablePromise(Promise.reject({
    statusCode,
    data
  }));
};

export default function createProvider(fetcher) {
  let fetcherOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const withCache = typeof fetcherOptions.cacheTime === "number" && fetcherOptions.cacheTime > 0;
  const expireTime = fetcherOptions.cacheTime;
  const cache = new Cache(expireTime);
  const mockedData = new Cache();

  const provider = function () {
    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }

    const key = JSON.stringify(params.filter(p => p !== null && p !== undefined));

    if (provider.mocker) {
      // Return promise with custom mocker
      const {
        data,
        statusCode
      } = provider.mocker(...params);
      return createPromiseMock(data, statusCode);
    } // return mock data if exist


    const mockPromise = mockedData.get(key);

    if (mockPromise) {
      return mockPromise;
    }

    const cachePromise = cache.get(key);

    if (withCache && cachePromise && !cachePromise.isCancelled) {
      return cachePromise;
    }

    const promise = makeCancellablePromise(fetcher(...params));

    if (withCache) {
      cache.add(key, promise);
      promise.catch(function () {
        cache.delete(key); // eslint-disable-next-line

        Promise.reject(...arguments);
      });
    }

    return promise;
  };

  provider.mock = function (_ref) {
    let {
      data,
      statusCode
    } = _ref;

    for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      params[_key2 - 1] = arguments[_key2];
    }

    const key = JSON.stringify(params);
    mockedData.add(key, createPromiseMock(data, statusCode));
    return () => {
      mockedData.delete(key);
    };
  };

  provider.setMocker = mocker => {
    provider.mocker = mocker;
    return () => {
      provider.mocker = undefined;
    };
  };

  return provider;
}
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(makeCancellablePromise, "makeCancellablePromise", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/utils/provider/provider.js");
  reactHotLoader.register(createPromiseMock, "createPromiseMock", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/utils/provider/provider.js");
  reactHotLoader.register(createProvider, "createProvider", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/utils/provider/provider.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();